import { TableTemplate } from "components/templates/default/table/TableTemplate";
import {
  SelectGroup,
  VIDEO_GUIDE_TYPE,
  VideoGuideSetting,
} from "api/interfaces/managerInterface.interface";
import * as s from "./VideoManagerStyled";
import AddVideo from "./add/video";
import { TableColumnsType } from "antd";
import AddPdf from "./add/pdf";
import { HelpGuideGroup } from "hook/useHelpGuideApi";
import { videoGuideOptions } from "utils/options";
import VideoSidebarPresenter from "./sidebar/VideoSidebarPresenter";
import VideoListPresenter from "./sidebar/VideoListPresenter";
import DeleteConfirmModal from "components/templates/modal/small/confirm/delete";
import AddGroup from "./add/group";
import { CommonTable } from "components/atoms/table/AntdTable";

type Props = {
  onModal: (type: VIDEO_GUIDE_TYPE, isEdit: boolean) => void;
  data: VideoGuideSetting[];
  groups: HelpGuideGroup[];
  groupsIsFetching: boolean;
  columns: TableColumnsType<VideoGuideSetting>;
  isGroupAddModal: boolean;
  isGroupEditModal: boolean;
  isVideoAddModal: boolean;
  isVideoEditModal: boolean;
  isPdfAddModal: boolean;
  isPdfEditModal: boolean;
  isDeleteConfirm: boolean;
  setIsDeleteConfirm: (value: boolean) => void;
  treeRef: React.MutableRefObject<any>;
  selectGroup: SelectGroup;
  selectedVideo: VideoGuideSetting | undefined;
  onClickGroup: (id: string) => void;
  onClickEditGroup: (id: string) => void;
  onClickDelete: (item: VideoGuideSetting) => void;
  getHelpGuides: () => void;
  getHelpGuideGroups: () => void;
  buttons: React.ReactNode;
};

export function VideoManagerPresenter(props: Props): JSX.Element {
  return (
    <TableTemplate buttons={props.buttons} noSearch>
      <s.Grid>
        <VideoSidebarPresenter
          data={[
            {
              id: videoGuideOptions[0].value,
              name: videoGuideOptions[0].label,
              position: 1,
              children: (props.groups || []).map((group) => ({
                id: group.groupId || "",
                name: group.groupName || "",
                position: group.sortOrder || 0,
                children: [],
              })),
            },
          ]}
          onClickGroup={props.onClickGroup}
          onClickEditGroup={props.onClickEditGroup}
          onModal={props.onModal}
          treeRef={props.treeRef}
          isGroupAddModal={props.isGroupAddModal}
          isGroupEditModal={props.isGroupEditModal}
          selectGroup={props.selectGroup}
        />
        <CommonTable
          columns={props.columns}
          dataSource={props.data}
          loading={false}
        />
      </s.Grid>
      {(props.isVideoAddModal || props.isVideoEditModal) &&
        props.selectGroup.layout === "slide" && (
          <AddVideo
            groups={props.groups}
            groupsIsFetching={props.groupsIsFetching}
            selectedGroup={props.selectGroup}
            isEdit={props.isVideoEditModal}
            onModal={() =>
              props.onModal(VIDEO_GUIDE_TYPE.YOUTUBE, props.isVideoEditModal)
            }
            selectedVideo={props.selectedVideo}
            maxPosition={
              props.isVideoEditModal ? props.data.length : props.data.length + 1
            }
            getHelpGuides={props.getHelpGuides}
          />
        )}
      {(props.isPdfAddModal || props.isPdfEditModal) &&
        props.selectGroup.layout === "table" && (
          <AddPdf
            groups={props.groups}
            groupsIsFetching={props.groupsIsFetching}
            selectedGroup={props.selectGroup}
            isEdit={props.isPdfEditModal}
            onModal={() =>
              props.onModal(VIDEO_GUIDE_TYPE.PDF, props.isPdfEditModal)
            }
            selectedVideo={props.selectedVideo}
            maxPosition={
              props.isPdfEditModal ? props.data.length : props.data.length + 1
            }
            getHelpGuides={props.getHelpGuides}
          />
        )}
      {props.isDeleteConfirm && (
        <DeleteConfirmModal
          label="VideoGuide"
          onDelete={() => props.setIsDeleteConfirm(false)}
          onConfirmDelete={() => {
            props.setIsDeleteConfirm(false);
            if (!props.selectedVideo) {
              return;
            }
            props.onClickDelete(props.selectedVideo);
          }}
        />
      )}
      {(props.isGroupAddModal || props.isGroupEditModal) && (
        <AddGroup
          isEdit={props.isGroupEditModal}
          onModal={() =>
            props.onModal(VIDEO_GUIDE_TYPE.GROUP, props.isGroupEditModal)
          }
          maxPosition={
            props.isGroupEditModal
              ? props.groups.length
              : props.groups.length + 1
          }
          selectedGroup={props.selectGroup}
          getHelpGuideGroups={props.getHelpGuideGroups}
          groups={props.groups}
        />
      )}
    </TableTemplate>
  );
}
